module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive--dark-ee632ad89c0c1b9f569c361814aa1da2.png";